import { render, staticRenderFns } from "./GreenTransportForm.vue?vue&type=template&id=42359c99&scoped=true&"
import script from "./GreenTransportForm.vue?vue&type=script&lang=js&"
export * from "./GreenTransportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42359c99",
  null
  
)

export default component.exports